import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';

@Injectable({ providedIn: 'root' })
export class NewsletterService {
  constructor(private readonly http: HttpClient) {}

  subscribe(email: string): Observable<{ ok: true }> {
    return this.http.post<{ ok: true }>(`${API_BASE_URL}/newsletter/subscribe`, {
      email,
    });
  }
}
